import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Calendar2Week,
  BoxArrowUpRight,
  Person,
} from "react-bootstrap-icons";


import "./LinksPage.css";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";

export default function LinksPage({ profile }) {
  const { user } = useAuthContext();

  const slug = profile?.slug || profile?.Slug || "";

  const [publicAvailabilityEnabled, setPublicAvailabilityEnabled] =
    useState(false);

  const [updatingAvailability, setUpdatingAvailability] = useState(false);

  useEffect(() => {
    setPublicAvailabilityEnabled(
      profile?.publicAvailabilityEnabled ??
        profile?.PublicAvailabilityEnabled ??
        false
    );
  }, [profile]);

  const clientLoginLink = slug ? `/${slug}/login` : "";
  const availabilityLink = slug ? `/availability/${slug}` : "";

  const copyLink = async (path) => {
    if (!path) return;

    const fullUrl = `${window.location.origin}${path}`;
    await navigator.clipboard.writeText(fullUrl);
  };

  const togglePublicAvailability = async () => {
    setUpdatingAvailability(true);

    try {
      const response = await axios.put(
        `${ApiConnectionString}/api/therapist/settings/public-availability`,
        {
          PublicAvailabilityEnabled: !publicAvailabilityEnabled,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setPublicAvailabilityEnabled(
        response.data.publicAvailabilityEnabled ??
          response.data.PublicAvailabilityEnabled
      );
    } catch (error) {
      console.error(error);
    } finally {
      setUpdatingAvailability(false);
    }
  };

  return (
    <div className="links-page">
      <div className="links-header">
        <h1>Links</h1>
        <p>Share useful links with your clients.</p>
      </div>

      {!slug ? (
        <div className="links-card">
          <p>Your practice link is not available yet.</p>
        </div>
      ) : (
        <div className="links-grid">
          <section className="links-card">
            <div className="links-card-icon">
              <Person />
            </div>

            <div className="links-card-content">
              <span>Client portal</span>
              <h2>Client login link</h2>
              <p>Clients can use this link to log in to their portal.</p>

              <div className="links-url">
                {window.location.origin}
                {clientLoginLink}
              </div>

              <div className="links-actions">
                <button
                  type="button"
                  onClick={() => copyLink(clientLoginLink)}
                >
                  Copy link
                </button>
              </div>
            </div>
          </section>

          <section
            className={`links-card availability-card ${
              !publicAvailabilityEnabled
                ? "availability-card-disabled"
                : ""
            }`}
          >
            <div className="links-card-icon">
              <Calendar2Week />
            </div>

            <div className="links-card-content">
              <div className="availability-heading">
                <span>Public availability</span>

                <span
                  className={`availability-status ${
                    publicAvailabilityEnabled
                      ? "availability-status-on"
                      : "availability-status-off"
                  }`}
                >
                  Currently {publicAvailabilityEnabled ? "on" : "off"}
                </span>
              </div>

              <h2>Availability page</h2>

              <p>
                {publicAvailabilityEnabled
                  ? "People can view your general availability without logging in."
                  : "Your public availability page is currently disabled and cannot be accessed by visitors."}
              </p>

              <div className="links-url">
                {window.location.origin}
                {availabilityLink}
              </div>

              <div className="links-actions">
                {publicAvailabilityEnabled && (
                  <>
                    <Link
                      to={availabilityLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Open <BoxArrowUpRight />
                    </Link>

                    <button
                      type="button"
                      onClick={() => copyLink(availabilityLink)}
                    >
                      Copy link
                    </button>
                  </>
                )}

                <button
                  type="button"
                  className="availability-toggle"
                  onClick={togglePublicAvailability}
                  disabled={updatingAvailability}
                >
                  {updatingAvailability
                    ? "Updating..."
                    : publicAvailabilityEnabled
                      ? "Disable public page"
                      : "Enable public page"}
                </button>
              </div>
            </div>
          </section>
        </div>
      )}
    </div>
  );
}